<template>
  <div class="content">
    <el-card>
      <el-form ref="formPad" :inline="true" :model="listQuery" class="form_pad">
        <el-row class="clear_fix">
          <el-form-item :label="$t('common.searchRule')">
            <el-input 
              :placeholder="$t('common.enterRuleName')" 
              style="width: 200px" 
              v-model="listQuery.name" 
              class="input-with-select"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('common.searchID')">
            <el-input 
              :placeholder="$t('common.searchID')" 
              style="width: 200px" 
              v-model="listQuery.id" 
              class="input-with-select"
            ></el-input>
          </el-form-item>
        </el-row>
        <el-row class="search-btns">
          <el-button type="primary" icon="el-icon-search" @click="getBlockedRules">
            {{ $t('common.search') }}
          </el-button>
        </el-row>
      </el-form>
    </el-card>

    <div class="mb10">
      <el-button type="primary" class="handle-del mr10" @click="handleAdd">
        {{$t("common.addRule")}}
      </el-button>
    </div>
    <div class="main-container">
      <el-card class="left-panel">
        <div class="rule-list">
          <div 
            v-for="rule in ruleList" 
            :key="rule.id"
            class="rule-item"
            :class="{ 'is-active': currentRuleId === rule.id }"
            @click="handleSelectRule(rule)"
          >
            <div class="rule-info">
              <div class="rule-name">{{ rule.name }}</div>
              <div class="id-desc">ID: {{ rule.id }}</div>
              <div class="type-tag-line">
                <el-tag
                  v-if="rule.bundles.length"
                  size="small"
                  class="dimension-tag type"
                >
                  {{ $t('block.app') }}
                </el-tag>
                <el-tag
                  v-if="rule.domains.length"
                  size="small"
                  class="dimension-tag type"
                >
                  {{ $t('block.domain') }}
                </el-tag>
                <el-tag
                  v-if="rule.categories.length"
                  size="small"
                  class="dimension-tag type"
                >
                  {{ $t('block.category') }}
                </el-tag>
              </div>
            </div>
          </div>
        </div>
      </el-card>
      <el-card class="right-panel" v-if="currentRuleId" v-loading="loading">
        <div slot="header" class="detail-header">
          <div class="id-area">
            <div class="id-label">{{ ruleDetail.name }}</div>
            <div class="id-desc">ID: {{ ruleDetail.id }}</div>
            <!-- 最后一次新建/编辑这条规则的账号邮箱和时间，账号被停用或删除后仍然保留 -->
            <div class="id-desc">
              {{ $t('table.operator') }}: {{ ruleDetail.operator_email || '--' }}
            </div>
            <div class="id-desc">
              {{ $t('table.operateTime') }}: {{ ruleDetail.updated_at | datetime }}
            </div>
          </div>
          <div class="operation">
            <i class="el-icon-document-copy" @click="handleCopy"></i>
            <i class="el-icon-edit" @click="handleEdit"></i>
            <i class="el-icon-delete" @click="handleDelete"></i>
          </div>
        </div>
        
        <div class="detail-view">
          <div class="dimension-section">
            <div class="section-title">
              {{ $t('block.blockApp') }} ({{ ruleDetail.bundles.length}})
            </div>
            <div class="section-content">
              <el-tag v-for="app in ruleDetail.bundles" :key="app" size="small" class="dimension-tag">
                {{ app }}
              </el-tag>
            </div>
          </div>
          
          <div class="dimension-section">
            <div class="section-title">
              {{ $t('block.blockDomain') }} ({{ ruleDetail.domains.length}})
            </div>
            <div class="section-content">
              <el-tag v-for="domain in ruleDetail.domains" :key="domain" size="small" class="dimension-tag">
                {{ domain }}
              </el-tag>
            </div>
          </div>
          
          <div class="dimension-section">
            <div class="section-title">
              {{ $t('block.blockCategory') }} ({{ ruleDetail.categories.length}})
            </div>
            <div class="section-content">
              <el-tag v-for="cat in ruleDetail.categories" :key="cat" size="small" class="dimension-tag">
                {{ formatCategoriesForEcho(cat) }}
              </el-tag>
            </div>
          </div>
          
          <!-- <div class="dimension-section">
            <div class="section-title">
              {{ $t('block.blockKeyword') }} ({{ ruleDetail.keywords.length }})
            </div>
            <div class="section-content">
              <el-tag v-for="keyword in ruleDetail.keywords" :key="keyword" size="small" class="dimension-tag">
                {{ keyword }}
              </el-tag>
            </div>
          </div> -->
          <div class="dimension-section">
            <div class="section-title">{{ $t('block.effectScope') }}</div>
            <div class="section-content">
              <el-tag v-for="app in ruleDetail.app_ids" :key="app" size="small" class="dimension-tag">
                {{ appIdMap[app] || app }}
              </el-tag>
            </div>
          </div>
        </div>
      </el-card>
      <el-card class="right-panel empty-panel" v-else>
        <div class="empty-tip">
          <i class="el-icon-info"></i>
          <p>{{ $t('message.noData') }}</p>
        </div>
      </el-card>
    </div>

    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="700px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      class="rule-dialog"
      :before-close="beforeCloseDialog"
    >
      <el-form 
        ref="ruleFormRef"
        :model="ruleForm" 
        label-width="120px" 
        size="small"
        label-position="right"
      >

      <div class="section-block-title">
        <span>{{ $t('block.blockContent') }}</span>
      </div>
      <el-form-item :label="`${$t('block.app')} (${ruleForm.bundles.length || 0})`">
        <el-input
          type="textarea"
          v-model="bundleInput"
          :placeholder="$t('dialog.enterApp')"
          :rows="4"
          @blur="handleBundleInput"
        ></el-input>
        <div class="tag-list" v-if="ruleForm.bundles.length > 0">
          <el-tag
            v-for="(bundle, index) in ruleForm.bundles"
            :key="index"
            size="small"
            closable
            @close="removeBundle(bundle)"
          >
            {{ bundle }}
          </el-tag>
        </div>
      </el-form-item>
      <el-form-item :label="`${$t('block.domain')} (${ruleForm.domains.length || 0})`">
        <el-input
          type="textarea"
          v-model="domainInput"
          :placeholder="$t('dialog.enterDomain')"
          :rows="4"
          @blur="handleDomainInput"
        ></el-input>
        <div class="tag-list" v-if="ruleForm.domains.length > 0">
          <el-tag
            v-for="(domain, index) in ruleForm.domains"
            :key="index"
            size="small"
            closable
            @close="removeDomain(domain)"
          >
            {{ domain }}
          </el-tag>
        </div>
      </el-form-item>
      <el-form-item :label="`${$t('block.category')} (${ruleForm.categories.length || 0})`">
        <el-cascader
          v-model="ruleForm.categories"
          :options="categoryOptions"
          :props="{ multiple: true, checkStrictly: false, emitPath: false }"
          collapse-tags
          clearable
          style="width: 100%"
          :placeholder="$t('dialog.enterCategory')"
        ></el-cascader>
      </el-form-item>

      <!-- <el-form-item :label="`${$t('block.keyword')} (${ruleForm.keywords.length || 0})`">
        <el-input
          type="textarea"
          v-model="keywordInput"
          :placeholder="$t('dialog.enterKeyword')"
          :rows="4"
          @blur="handleKeywordInput"
        ></el-input>
        <div class="tag-list" v-if="ruleForm.keywords.length > 0">
          <el-tag
            v-for="(keyword, index) in ruleForm.keywords"
            :key="index"
            size="small"
            closable
            @close="removeKeyword(keyword)"
          >
            {{ keyword }}
          </el-tag>
        </div>
      </el-form-item> -->

      <div class="section-block-title">
        <span>{{ $t('block.effectScope') }}</span>
      </div>
        <div class="app-scope-item">
        <el-tag effect="dark" size="small" class="app-tag">
          {{ $t('block.app') }} 
        </el-tag>
        
        <el-select
          v-model="ruleForm.app_ids"
          placeholder="请选择生效范围"
          size="small"
          class="app-select"
          multiple
          clearable
        >
          <el-option
            v-for="app in appList"
            :key="app.id"
            :label="app.name"
            :value="app.id"
          />
        </el-select>
      </div>
      <div class="section-block-title">
        <span>{{ $t('block.ruleName') }}</span>
      </div>
      <div style="margin-top:12px">
        <el-input 
          v-model="ruleForm.name" 
          :placeholder="$t('common.enterRuleName')"
        ></el-input>
      </div>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleCancel" size="small">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="handleSave" :loading="saving" size="small">
        {{ $t('save') }}
      </el-button>
    </div>
  </el-dialog>
  <el-dialog
    :title="$t('dialog.confirmLeave')"
    :visible.sync="cancelDialogVisible"
    width="400px"
    append-to-body
  >
    <span>{{ $t('dialog.message') }}</span>
    <span slot="footer" class="dialog-footer">
      <el-button @click="cancelDialogVisible = false" size="small">
        {{ $t('dialog.no') }}
      </el-button>
      <el-button type="primary" @click="confirmCancel" size="small">
        {{ $t('dialog.yes') }}
      </el-button>
    </span>
  </el-dialog>
  </div>
</template>

<script>
import { datetime } from '@/utils/subAccount/format'

const defaultRuleForm = {
  id: 0,
  name: '',
  bundles: [],
  domains: [],
  categories: [],
  keywords: [],
  app_ids: []
}

export default {
  name: 'BlockRuleManagement',
  data() {
    return {
      listQuery: {
        name: '',
        id: '',
      },
      ruleList: [],
      appList: [],
      categoryOptions: [],
      currentRuleId: null,
      ruleDetail: {
        id: 0,
        name: '',
        bundles: [],
        domains: [],
        categories: [],
        keywords: [],
        app_ids: []
      },   
      dialogVisible: false,
      loading: false,
      dialogTitle: '',
      ruleForm: Object.assign({}, defaultRuleForm),
      bundleInput: '',
      domainInput: '',
      keywordInput: '',
      saving: false,
      cancelDialogVisible: false,
      isEdit: false,
      originalForm: null
    }
  },
  created() {
    this.getBlockedRules()
    this.getCategoryTrees()
    this.getAppScopeList()
  },
  computed: {
    appIdMap() {
      return this.appList.reduce((map, item) => {
        map[item.id] = item.name
        return map
      }, {})
    }
  },
  filters: {
    datetime
  },
  methods: {
    getAppScopeList() {
      this.__getData('getAppScopeList', null, res => {    
        this.appList = res.list
      })
    },
    getBlockedRules() {
      let params = this.listQuery
      this.__getData('getBlockedRules',params, res => {  
        if(res.code == 1) {  
          this.$message.error(res.msg)
        }else {
          this.ruleList = res.list
        }
      })
    },
    getCategoryTrees() {
      this.__getData('getCategoryTrees', null, res => {    
        this.categoryOptions = this.buildCategoryTree(res)
      })
    },
    buildCategoryTree(flatData) {
      const nodeMap = {}
      flatData.forEach(item => {
        nodeMap[item.id] = {
          value: item.id, 
          label: item.name,
          parentId: item.parent_id 
        }
      })

      const parentChildrenMap = {}
      flatData.forEach(item => {
        if (item.parent_id !== 0) {
          if (!parentChildrenMap[item.parent_id]) {
            parentChildrenMap[item.parent_id] = []
          }
          parentChildrenMap[item.parent_id].push(nodeMap[item.id])
        }
      })

      const treeData = []
      flatData.forEach(item => {
        const currentNode = nodeMap[item.id]
        if (parentChildrenMap[item.id]) {
          currentNode.children = parentChildrenMap[item.id]
        }
        if (item.parent_id === 0) {
          treeData.push(currentNode)
        }
      })

      return treeData
    },
    findCategoryPath(childId, tree = this.categoryOptions, parentPath = []) {
      for (const node of tree) {
        const currentPath = [...parentPath, node.value]
        
        if (node.value === childId) {
          return currentPath
        }
        
        if (node.children) {
          const found = this.findCategoryPath(childId, node.children, currentPath)
          if (found) return found
        }
      }
      return null
    },
    formatCategoriesForEcho(childId) {
      if (!childId) return ''
      
      const path = this.findCategoryPath(childId)
      return path ? this.formatCategoryLabel(path) : childId
    },
    formatCategoryLabel(cat) {
      if (Array.isArray(cat)) {
        let labels = []
        let currentOptions = this.categoryOptions
        
        for (const value of cat) {
          const found = currentOptions.find(item => item.value === value)
          if (found) {
            labels.push(found.label)
            currentOptions = found.children || []
          }
        }
        return labels.join(' / ')
      }
      return cat
    },
    mergeParent(nodes) {
      const set = new Set(nodes)
      const pmap = new Map()

      const walk = (arr, pid = null) => arr.forEach(n => {
        if (pid != null) {
          if (!pmap.has(pid)) pmap.set(pid, [])
          pmap.get(pid).push(n.value)
        }
        if (n.children && n.children.length) walk(n.children, n.value)
      })
      walk(this.categoryOptions)
      pmap.forEach((children, pid) => {
        if (children.every(id => set.has(id))) {
          children.forEach(id => set.delete(id))
          set.add(pid)
        }
      })
      return [...set]
    },
    getParentLeafMap() {
      const map = new Map()
      const walk = (arr, pid = null) => {
        arr.forEach(n => {
          if (pid != null) {
            if (!map.has(pid)) map.set(pid, [])
            // 只收集叶子
            if (!n.children || !n.children.length) map.get(pid).push(n.value)
          }
          if (n.children && n.children.length) walk(n.children, n.value)
        })
      }
      walk(this.categoryOptions)
      return map
    },
    expandParentToLeaf(ids) {
      const pmap = this.getParentLeafMap()
      const res = []
      ids.forEach(id => {
        if (pmap.has(id)) {
          res.push(...pmap.get(id))   
        } else {
          res.push(id)                
        }
      })
      return [...new Set(res)]        
    },
    handleSelectRule(rule) {
      this.currentRuleId = rule.id
      this.fetchRuleDetail(rule.id)
    },
    fetchRuleDetail(id) {
      this.ruleDetail = this.ruleList.find(item => item.id === id)
    },
    handleAdd() {
      this.isEdit = false
      this.dialogTitle = this.$t('dialog.addRule')
      this.ruleForm = Object.assign({}, defaultRuleForm)
      this.bundleInput = ''
      this.domainInput = ''
      this.keywordInput = ''
      this.originalForm = null
      this.dialogVisible = true
      this.originalForm = JSON.stringify(this.ruleForm)
    },
    handleEdit() {
      this.isEdit = true
      this.dialogTitle = this.$t('dialog.editRule')
      const expanded = this.expandParentToLeaf(this.ruleDetail.categories)
      this.ruleForm = {
        id: this.ruleDetail.id,
        name: this.ruleDetail.name,
        bundles: [...this.ruleDetail.bundles],
        domains: [...this.ruleDetail.domains],
        categories: expanded,
        keywords: [...this.ruleDetail.keywords],
        app_ids: [...this.ruleDetail.app_ids]
      }
      this.originalForm = JSON.stringify(this.ruleForm)
      this.dialogVisible = true
    },
    
    handleCopy() {
      this.isEdit = false
      this.dialogTitle = this.$t('dialog.addRule')
      const expanded = this.expandParentToLeaf(this.ruleDetail.categories)
      this.ruleForm = {
        id: 0,
        name: `${this.ruleDetail.name}_copy`,
        bundles: [...this.ruleDetail.bundles],
        domains: [...this.ruleDetail.domains],
        categories: expanded,
        keywords: [...this.ruleDetail.keywords],
        app_ids: [...this.ruleDetail.app_ids]
      }
      this.originalForm = JSON.stringify(this.ruleForm)
      this.dialogVisible = true
    },
    handleDelete() {
      this.$confirm(this.$t('message.deleteMessage'), this.$t('message.confirmDelete'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning'
      }).then(() => {
        this.__postData('deleteBlockedRule', {id: this.currentRuleId} , (res) => {
          if(res.code == 1) {
            this.$message.error(res.msg)
          }else {
            this.$message.success(this.$t('message.delete'))
            this.getBlockedRules()
            this.currentRuleId = null
            this.ruleDetail = Object.assign({}, defaultRuleForm)
          }
        })
      }).catch(() => {})
    },
    handleBundleInput() {
      if (this.bundleInput) {
        const rawArr = this.bundleInput.split(/[\n,]/).map(d => d.trim()).filter(d => d)
        // 输入框内去重，统计重复项
        const seen = new Set()
        const inputArr = []
        let inputRepeatCount = 0
        rawArr.forEach(item => {
          if (seen.has(item)) {
            inputRepeatCount++
          } else {
            seen.add(item)
            inputArr.push(item)
          }
        })
        // 校验规则：必须包含.，不能以.开头或结尾，只能包含英文/数字，长度≤200
        const validArr = inputArr.filter(d => {
          return /\./.test(d) &&
            !/^\./.test(d) &&
            !/\.$/.test(d) &&
            /^[A-Za-z0-9.]+$/.test(d)
        })
        const invalidArr = inputArr.filter(d => !validArr.includes(d))
        const oldArr = this.ruleForm.bundles
        const newArr = validArr.filter(d => !oldArr.includes(d))
        const repeatArr = validArr.filter(d => oldArr.includes(d))
        this.ruleForm.bundles = [...oldArr, ...newArr]
        this.bundleInput = ''
        let msg = ''
        if (inputRepeatCount > 0) msg += `${inputRepeatCount} ${this.$t('dialog.appRepeatMessage')}`
        if (invalidArr.length > 0) msg += `${invalidArr.length} ${this.$t('dialog.appInvaildMessage')}`
        if (repeatArr.length > 0) msg += `${repeatArr.length} ${this.$t('dialog.appRepeatMessage')}`
        if (msg) this.$message.warning(msg)
      }
    },
    removeBundle(bundle) {
      this.ruleForm.bundles = this.ruleForm.bundles.filter(b => b !== bundle)
    },
    handleDomainInput() {
      if (this.domainInput) {
        const rawArr = this.domainInput.split(/[\n,]/).map(d => d.trim()).filter(d => d)
        // 输入框内去重，统计重复项
        const seen = new Set()
        const inputArr = []
        let inputRepeatCount = 0
        rawArr.forEach(item => {
          if (seen.has(item)) {
            inputRepeatCount++
          } else {
            seen.add(item)
            inputArr.push(item)
          }
        })
        const validArr = inputArr.filter(d => {
          return  /\./.test(d) &&
            !/^\./.test(d) &&
            !/\.$/.test(d) &&
            /^[A-Za-z0-9.]+$/.test(d)
        })
        const invalidArr = inputArr.filter(d => !validArr.includes(d))
        const oldArr = this.ruleForm.domains
        const newArr = validArr.filter(d => !oldArr.includes(d))
        const repeatArr = validArr.filter(d => oldArr.includes(d))
        this.ruleForm.domains = [...oldArr, ...newArr]
        this.domainInput = ''
        let msg = ''
        if (inputRepeatCount > 0) msg += `${inputRepeatCount} ${this.$t('dialog.domainRepeatMessage')}`
        if (invalidArr.length > 0) msg += `${invalidArr.length} ${this.$t('dialog.domainInvaildMessage')}`
        if (repeatArr.length > 0) msg += `${repeatArr.length} ${this.$t('dialog.domainRepeatMessage')}`
        if (msg) this.$message.warning(msg)
      }
    },
    removeDomain(domain) {
      this.ruleForm.domains = this.ruleForm.domains.filter(d => d !== domain)
    },
    /* handleKeywordInput() {
      if (this.keywordInput) {
        const inputArr = this.keywordInput.split(/[\n,]/).map(d => d.trim()).filter(d => d)
        const oldArr = this.ruleForm.keywords
        const newArr = inputArr.filter(d => !oldArr.includes(d))
        const repeatArr = inputArr.filter(d => oldArr.includes(d))

        this.ruleForm.keywords = [...oldArr, ...newArr]
        this.keywordInput = ''

        if (repeatArr.length > 0) {
          this.$message.warning(`${repeatArr.length} 个重复关键词已忽略`)
        }
      }
    },
    removeKeyword(keyword) {
      this.ruleForm.keywords = this.ruleForm.keywords.filter(k => k !== keyword)
    }, */
    beforeCloseDialog() {
      this.handleCancel()
    },
    handleCancel() {
      if (this.originalForm !== JSON.stringify(this.ruleForm)) {
        this.cancelDialogVisible = true
      } else {
        this.handleDialogClose()
        this.dialogVisible = false
      }
    },  
    confirmCancel() {
      this.cancelDialogVisible = false
      this.handleDialogClose()
      this.dialogVisible = false     
    },
    
    // 保存
    handleSave() {
      this.$refs.ruleFormRef.validate((valid) => {
        if (valid) {
          if (this.ruleForm.app_ids.length === 0) {
            this.$message.warning(this.$t('dialog.selectEffectScope'))
            return
          }
          if (!this.ruleForm.name) {
            this.$message.warning(this.$t('dialog.enterRuleName'))
            return
          }
          this.saving = true
          const params = { 
            ...this.ruleForm,
            bundles: this.ruleForm.bundles.join('\n'),
            domains: this.ruleForm.domains.join('\n'),
            keywords: this.ruleForm.keywords.join('\n'),
            categories: this.mergeParent(this.ruleForm.categories)
          }
          console.log('params', params)
          this.__postData('updateBlockedRule', params , (res) => {
            this.saving = false
            if(res.code == 1) {
              this.$message.error(res.msg)
            }else {
              if(this.isEdit) {
                if(res.data) {
                  this.$message.error(res.data)
                }else {
                  this.$message.success(this.$t('message.edit'))
                }
              }else {
                if(res.data) {
                  this.$message.error(res.data)
                }else {
                  this.$message.success(this.$t('message.add'))
                }
              }
              this.dialogVisible = false

              this.loading = true          
              this.__getData('getBlockedRules', this.listQuery, res => {
                this.loading = false       
                if (res.code == 1) {
                  this.$message.error(res.msg)
                } else {
                  this.ruleList = res.list
                  if (this.ruleForm.id) {
                    this.fetchRuleDetail(this.ruleForm.id)
                  }
                }
              })
            }
          })
        }
      })
    },
    handleDialogClose() {
      this.ruleForm = Object.assign({}, defaultRuleForm)
      this.bundleInput = ''
      this.domainInput = ''
      this.keywordInput = ''
      this.originalForm = null
      this.$refs.ruleFormRef.clearValidate()
    }
  }
}
</script>

<style scoped>
.main-container {
  display: flex;
  gap: 20px;
  max-height: 700px;
}

.left-panel {
  flex: 0 0 320px;
}

.right-panel {
  max-height: 700px;
  overflow-y: auto;
  flex: 1;
}

.empty-panel {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 400px;
}
.rule-list {
  max-height: 600px;
  overflow-y: auto;
}

.rule-item {
  padding: 12px 16px;
  border-bottom: 1px solid #ebeef5;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: all 0.3s;
}

.rule-item:hover {
  background-color: #f5f7fa;
}

.rule-item.is-active {
  background-color: #ecf5ff;
  border-left: 3px solid #409eff;
}

.rule-info {
  flex: 1;
}

.rule-name {
  font-size: 14px;
  color: #303133;
  margin-bottom: 4px;
  font-weight: 500;
}

.rule-time {
  font-size: 12px;
  color: #909399;
}
.detail-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.id-area {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.id-label {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
}

.id-desc {
  font-size: 12px;
  color: #909399;
}

.operation {
  display: flex;
  gap: 16px;
  font-size: 18px;
  color: #606266;
}

.operation i {
  cursor: pointer;
  padding: 4px;
  transition: all 0.3s;
}

.operation i:hover {
  color: #409eff;
  transform: scale(1.1);
}
.detail-view {
  padding: 10px;
}

.dimension-section {
  margin-bottom: 24px;
}

.dimension-section:last-child {
  margin-bottom: 0;
}

.section-title {
  font-size: 14px;
  font-weight: bold;
  color: #303133;
  margin-bottom: 12px;
  padding-left: 8px;
  border-left: 3px solid #409eff;
}

.section-content {
  min-height: 30px;
  max-height: 90px;
  overflow-y: auto;
  padding: 12px;
  background-color: #f5f7fa;
  border-radius: 4px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.dimension-tag {
  margin: 0;
}

.type-tag-line {
  margin-top: 6px;
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}
.type   { background-color: #e6f7ff; border-color: #ECF5FF; color: #6c84d4; }

.empty-tip {
  text-align: center;
  color: #909399;
}

.empty-tip i {
  font-size: 48px;
  margin-bottom: 10px;
  color: #dcdfe6;
}

.empty-tip p {
  font-size: 14px;
}

.section-block-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 16px;
  padding: 0;
  border-left: none;
  display: flex;
  align-items: center;
  gap: 8px;
}

.rule-dialog >>> .el-form-item__label {
  font-weight: 500;
  color: #606266;
  padding-right: 12px;
}

.tag-list {
  margin-top: 8px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.tag-list .el-tag {
  margin: 0;
}

.dialog-footer {
  text-align: right;
  padding-top: 20px;
  border-top: 1px solid #ebeef5;
  margin-top: 20px;
}
.app-scope-item {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}

.app-tag {
  min-width: 100px; 
  text-align: center;
}

.app-select {
  flex: 1; 
}
</style>